export const GET_NOTIFICATION_LIST = 'GET_NOTIFICATION_LIST';
export const getNotificationList = (groupId, from, read) => ({
  type: GET_NOTIFICATION_LIST,
  payload: {
    groupId, from, read,
  },
});

export const MARK_NOTIFICATION_READ = 'MARK_NOTIFICATION_READ';
export const markNotificationRead = messageId => ({
  type: MARK_NOTIFICATION_READ,
  payload: {
    messageId,
  },
});
